import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppService } from '../../../../../service';

@Component({
  selector: 'app-reject-dialog',
  templateUrl: './reject-dialog.component.html',
  styleUrls: ['./reject-dialog.component.scss'],
})
export class RejectDialogComponent {
  @Input() title = '驳回';
  @Input() label = '驳回原因';
  @Input() placeholder = '请输入驳回原因';
  @Input() required = true;
  @Input() requiredMessage = '请输入驳回原因';

  rejectReason = '';
  readonly textareaMaxLength = 500;

  constructor(
    private modalController: ModalController,
    private appService: AppService,
  ) {}

  async cancel() {
    await this.modalController.dismiss(null);
  }

  async confirm() {
    const value = this.rejectReason ? this.rejectReason.trim() : '';
    if (this.required && !value) {
      this.appService.toastTip(this.requiredMessage, true);
      return;
    }
    await this.modalController.dismiss(value);
  }
}